import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { RelayRenderer as FinishLineRenderer } from 'finish-line';

const defaultPreprocessParams = (params) => params;

const Loading = () => (
  <div className="loading_container">
    <div className="lds-dual-ring"></div>
  </div>
);
const ErrorComponent = () => <div>Something went wrong!</div>;

export default class StoreProvider extends Component {
  render() {
    const { container, query, preprocessParams, ...otherProps } = this.props;

    const preprocessParamsWithDefault =
      preprocessParams || defaultPreprocessParams;

    return (
      <Route>
        {(routeProps) => (
          <FinishLineRenderer
            container={container}
            query={query}
            variables={preprocessParamsWithDefault(routeProps.match.params)}
            loading={Loading}
            error={ErrorComponent}
            {...otherProps}
            {...routeProps}
          />
        )}
      </Route>
    );
  }
}
